// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu {
  position: relative;
}

.user-menu-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  transition: background-color 0.3s;
  color: var(--main-text-color);
}

.user-menu-trigger:hover {
  background: rgba(127, 204, 159, 0.1);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--ar-buttons-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--secondary-color);
}

.user-initials {
  font-size: 12px;
  font-weight: 600;
  color: var(--main-text-color);
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  min-width: 280px;
  z-index: 1000;
  margin-top: 8px;
  overflow: hidden;
}

.user-menu-header {
  padding: 20px;
  background: var(--third-bg-color);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar-large {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--ar-buttons-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--secondary-color);
}

.user-initials-large {
  font-size: 18px;
  font-weight: 600;
  color: var(--main-text-color);
}

.user-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.user-name-large {
  font-size: 16px;
  font-weight: 600;
  color: var(--main-text-color);
}

.user-email {
  font-size: 14px;
  color: #666;
}

.user-role {
  font-size: 12px;
  color: var(--main-text-color-highligth);
  font-weight: 500;
  padding: 2px 8px;
  background: rgba(127, 204, 159, 0.1);
  border-radius: 4px;
  margin-top: 4px;
  align-self: flex-start;
}

.user-menu-divider {
  height: 1px;
  background: #e0e0e0;
}

.user-menu-items {
  padding: 8px;
}

.user-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  font-size: 14px;
  color: var(--main-text-color);
  transition: background-color 0.2s;
  text-align: left;
}

.user-menu-item:hover {
  background: rgba(127, 204, 159, 0.1);
}

.user-menu-item.logout-item {
  color: #f44336;
}

.user-menu-item.logout-item:hover {
  background: rgba(244, 67, 54, 0.1);
}

.menu-icon {
  font-size: 18px !important;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .user-name {
    display: none;
  }
  
  .user-menu-dropdown {
    min-width: 250px;
    right: -20px;
  }
  
  .user-menu-trigger {
    padding: 8px;
  }
  
  .user-avatar {
    width: 28px;
    height: 28px;
  }
  
  .user-initials {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .user-menu-dropdown {
    right: -40px;
    min-width: 220px;
  }
  
  .user-menu-header {
    padding: 16px;
  }
  
  .user-avatar-large {
    width: 40px;
    height: 40px;
  }
  
  .user-initials-large {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/header/UserMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".user-menu {\r\n  position: relative;\r\n}\r\n\r\n.user-menu-trigger {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 8px 12px;\r\n  border-radius: 8px;\r\n  transition: background-color 0.3s;\r\n  color: var(--main-text-color);\r\n}\r\n\r\n.user-menu-trigger:hover {\r\n  background: rgba(127, 204, 159, 0.1);\r\n}\r\n\r\n.user-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  background: var(--ar-buttons-bg);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 2px solid var(--secondary-color);\r\n}\r\n\r\n.user-initials {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--main-text-color);\r\n}\r\n\r\n.user-name {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  max-width: 120px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.user-menu-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\r\n  border: 1px solid #e0e0e0;\r\n  min-width: 280px;\r\n  z-index: 1000;\r\n  margin-top: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.user-menu-header {\r\n  padding: 20px;\r\n  background: var(--third-bg-color);\r\n}\r\n\r\n.user-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.user-avatar-large {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 50%;\r\n  background: var(--ar-buttons-bg);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 2px solid var(--secondary-color);\r\n}\r\n\r\n.user-initials-large {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--main-text-color);\r\n}\r\n\r\n.user-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.user-name-large {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--main-text-color);\r\n}\r\n\r\n.user-email {\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.user-role {\r\n  font-size: 12px;\r\n  color: var(--main-text-color-highligth);\r\n  font-weight: 500;\r\n  padding: 2px 8px;\r\n  background: rgba(127, 204, 159, 0.1);\r\n  border-radius: 4px;\r\n  margin-top: 4px;\r\n  align-self: flex-start;\r\n}\r\n\r\n.user-menu-divider {\r\n  height: 1px;\r\n  background: #e0e0e0;\r\n}\r\n\r\n.user-menu-items {\r\n  padding: 8px;\r\n}\r\n\r\n.user-menu-item {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 16px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  color: var(--main-text-color);\r\n  transition: background-color 0.2s;\r\n  text-align: left;\r\n}\r\n\r\n.user-menu-item:hover {\r\n  background: rgba(127, 204, 159, 0.1);\r\n}\r\n\r\n.user-menu-item.logout-item {\r\n  color: #f44336;\r\n}\r\n\r\n.user-menu-item.logout-item:hover {\r\n  background: rgba(244, 67, 54, 0.1);\r\n}\r\n\r\n.menu-icon {\r\n  font-size: 18px !important;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n  .user-name {\r\n    display: none;\r\n  }\r\n  \r\n  .user-menu-dropdown {\r\n    min-width: 250px;\r\n    right: -20px;\r\n  }\r\n  \r\n  .user-menu-trigger {\r\n    padding: 8px;\r\n  }\r\n  \r\n  .user-avatar {\r\n    width: 28px;\r\n    height: 28px;\r\n  }\r\n  \r\n  .user-initials {\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .user-menu-dropdown {\r\n    right: -40px;\r\n    min-width: 220px;\r\n  }\r\n  \r\n  .user-menu-header {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .user-avatar-large {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n  \r\n  .user-initials-large {\r\n    font-size: 16px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
